export default {"src":"/_next/static/media/grayMarker.718995e4.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};